import type { OpeningStatus } from '@/lib/opening-hours'

import { useEffect, useState } from 'react'
import { getOpeningStatus } from '@/lib/opening-hours'

// Calculé après le montage uniquement : le rendu serveur reste neutre (pas d'écart d'hydratation).
export const useOpeningStatus = (): OpeningStatus | null => {
    const [status, setStatus] = useState<OpeningStatus | null>(null)

    useEffect(() => {
        const update = () => setStatus(getOpeningStatus(new Date()))

        update()

        const timer = window.setInterval(update, 30000)

        return () => window.clearInterval(timer)
    }, [])

    return status
}
